import DetailsModal from './details-modal';

class NestedDetailsModal extends DetailsModal {
  constructor() {
    super();

    this.summaryToggle = this.querySelector('#nested-summary') as HTMLElement;
    if (this.summaryToggle) this.summaryToggle.addEventListener('click', this.onNestedSummaryClick.bind(this));

    const closeButton = this.querySelector('button[name="nested-modal-close"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.nestedClose.bind(this));
    }
  }

  onNestedSummaryClick(event: Event): void {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const details = target.closest('details');
    if (details) {
      if (details.hasAttribute('open')) {
        this.nestedClose();
      } else {
        this.open(event);
      }
    }
  }

  nestedClose(focusToggle: boolean = true): void {
    // Check if removeTrapFocus is available globally
    type RemoveTrapFocusFunction = (focusElement: HTMLElement | null) => void;
    const removeTrapFocusGlobal = (globalThis as unknown as { removeTrapFocus?: RemoveTrapFocusFunction })
      .removeTrapFocus;
    if (typeof removeTrapFocusGlobal === 'function') {
      removeTrapFocusGlobal(focusToggle ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }
}

if (!customElements.get('nested-details-modal')) {
  customElements.define('nested-details-modal', NestedDetailsModal);
}
